<template>
    <b-container fluid class="animated fadeIn">
        <h1>Acompanhamento do Protesto</h1>

        <b-row>
            <b-col md="12">
                <b-card>
                    <b-row class="justify-content-center my-2">
                        <b-col sm="12" md="10" lg="8" xl="4">
                            <label class="d-md-none d-sm-flex">Período Monitoramento</label>
                            <b-input-group
                                    id="data-monitoramento"
                                    class="mb-3 d-md-flex"
                                    prepend="Período Monitoramento:">
                                <vue-monthly-picker ref="dataMonitoramentoField" :clearOption="false"
                                                    v-model="dataMonitoramento" dateFormat="MM/YYYY"
                                                    :monthLabels="labelMes"/>
                                <b-input-group-append>
                                    <b-button @click="focusDataMonitoramento()"
                                              @click.stop.prevent="focusDataMonitoramento()" size="sm" text="Data"
                                              variant="primary"> <!---->
                                        <i class="fa fa-calendar" aria-hidden="true"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card class="card-dashboard">
                    <div style="margin: auto 0.5%;">
                        <b-row class="justify-content-between blocoFrustrados no-margin">
                            <Item ref="item0"
                                  titulo="Devolvido antes do Apontamento"
                                  tooltip="CDAs enviadas à CRA e devolvidas antes do Apontamento"
                                  :quantidadeTotal="obterTotal()"
                                  :item=0
                                  :ano=ano
                                  :mes=mes
                            />
                            <div class="largura-seta"></div>
                            <Item ref="item1"
                                  titulo="Devolvido após o Apontamento"
                                  :quantidadeTotal="obterTotal()"
                                  :item=1
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA, Apontadas e devolvidas após o Apontamento"
                            />
                            <div class="largura-seta"></div>
                            <Item ref="item2"
                                  titulo="Carta de Retirada ou de Protesto Indevido"
                                  :quantidadeTotal="obterTotal()"
                                  :item=2
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA e retiradas através da expedição pela PGE de Carta de Retirada ou de Carta de Protesto Indevido"
                            />
                            <div class="largura-seta"></div>
                            <Item ref="item3" class="no-padding"
                                  titulo="Protesto Sustado ou Suspenso Judicialmente"
                                  :quantidadeTotal="obterTotal()"
                                  :item=3
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA e com protesto Sustado ou Suspenso por ordem judicial"
                            />
                        </b-row>
                        <b-row class="justify-content-between no-margin">
                            <div class="largura-item">
                                <div class="seta">
                                    <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="largura-seta"></div>
                            <div class="largura-item">
                                <div class="seta">
                                    <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="largura-seta"></div>
                            <div class="largura-item">
                                <div class="seta">
                                    <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="largura-seta">
                                <div class="seta seta-interna">
                                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="largura-item no-padding">
                                <div class="seta">
                                    <i class="fa fa-level-up" aria-hidden="true"></i>
                                </div>
                            </div>
                        </b-row>
                        <b-row class="justify-content-between no-margin no-padding">
                            <Item ref="item4"
                                  titulo="Enviado"
                                  :quantidadeTotal="obterTotal()"
                                  class="blocoFluxo border-right-none"
                                  :item=4
                                  :ano=ano
                                  :mes=mes
                                  :size=3
                                  tooltip="CDAs enviadas à CRA e aguardando Protocolo (arquivo Confirmação)"
                            />
                            <div class="largura-seta blocoFluxo seta-fluxo">
                                <div class="seta seta-interna seta-align-top">
                                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                </div>
                            </div>
                            <Item ref="item5"
                                  titulo="Apontado"
                                  :quantidadeTotal="obterTotal()"
                                  class="blocoFluxo border-sides-none"
                                  :item=5
                                  :ano=ano
                                  :mes=mes
                                  :size=3
                                  tooltip="CDAs enviadas à CRA, Apontadas e aguardando Retorno (arquivo Solução)"
                            />
                            <div class="largura-seta blocoFluxo seta-fluxo">
                                <div class="seta seta-interna seta-align-top">
                                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                </div>
                            </div>
                            <Item ref="item6"
                                  titulo="Protestado"
                                  :quantidadeTotal="obterTotal()"
                                  class="blocoFluxo border-left-none"
                                  :item=6
                                  :ano=ano
                                  :mes=mes
                                  :size=3
                                  tooltip="CDAs enviadas à CRA, Apontadas, Protestadas e aguardando Pg/TAP (Pendente)"
                            />
                            <div class="largura-seta">
                                <div class="seta seta-interna seta-align-top">
                                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                </div>
                            </div>
                            <Item ref="item7"
                                  class="blocoExitoso border-down-exitoso no-padding"
                                  titulo="Dívida Paga/Parcelada e Guia FEPGE não emitida"
                                  :quantidadeTotal="obterTotal()"
                                  :item=7
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA, Apontadas e Protestadas, pago ou parcelado e Guia FEPGE ainda não emitida"
                            />
                        </b-row>
                        <b-row class="justify-content-between no-margin">
                            <div class="largura-item">
                            </div>
                            <div class="largura-seta">
                            </div>
                            <div class="largura-item">
                                <div class="seta">
                                    <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="largura-seta">
                            </div>
                            <div class="largura-item">
                            </div>
                            <div class="largura-seta">
                            </div>
                            <div class="largura-item blocoExitoso arrow-exitoso no-padding">
                                <div class="seta">
                                    <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                                </div>
                            </div>
                        </b-row>
                        <b-row class="justify-content-between blocoExitoso no-margin">
                            <Item ref="item8"
                                  titulo="Dívida Paga/Parcela no tríduo e CDA Quitada"
                                  :quantidadeTotal="obterTotal()"
                                  :item=8
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA, Apontadas, pagas no tríduo legal perante o Tabelionato e com CDA baixada por pagamento"
                            />
                            <div class="largura-seta">
                                <div class="seta seta-interna seta-align-top">
                                    <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                                </div>
                            </div>
                            <Item ref="item9"
                                  titulo="Dívida Paga/Parcela no tríduo e CDA Pendente"
                                  :quantidadeTotal="obterTotal()"
                                  :item=9
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA, Apontadas, pagas no tríduo legal perante o Tabelionato e com CDA ainda pendente"
                            />
                            <div class="largura-seta"></div>
                            <Item ref="item10"
                                  titulo="Carta de Anuência Expedida"
                                  :quantidadeTotal="obterTotal()"
                                  :item=10
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA, Apontadas e Protestadas, com CDA paga ou parcelada, Guia FEPGE paga e Carta de Anuência expedida ao Tabelionato"
                            />
                            <div class="largura-seta">
                                <div class="seta seta-interna seta-align-top">
                                    <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                                </div>
                            </div>
                            <Item ref="item11" class="no-padding"
                                  titulo="Dívida Paga/Parcelada e Guia FEPGE emitida"
                                  :quantidadeTotal="obterTotal()"
                                  :item=11
                                  :ano=ano
                                  :mes=mes
                                  tooltip="CDAs enviadas à CRA, Apontadas e Protestadas, com CDA paga ou parcelada e Guia SFEPGE emitida e aguardando pagamento"
                            />
                        </b-row>
                    </div>
                </b-card>

                <b-card>
                    <div style="margin: auto 0.5%;">
                        <b-row class="justify-content-between no-margin">
                            <div class="col-2 d-flex flex-column justify-content-center totais totais-esquerda">
                                <p>CDAs enviadas a Protesto</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding fundo-cinza">
                                <p>{{qtdTotalProtestos == null ? '...' : qtdTotalProtestos}}</p>
                            </div>
                            <div></div>
                            <div  class="col-2 d-flex flex-column justify-content-center totais">
                                <p>Fluxo de envio a CRA, APT e Protesto</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding blocoFluxo">
                                <p>{{obterFluxo()}}</p>
                            </div>
                            <div></div>
                            <div  class="col-2 d-flex flex-column justify-content-center totais totais-direita">
                                <p>Valor não recuperado da Remessa</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding blocoFrustrados">
                                <p>{{totaisRemessa.valorNaoRecuperado}}</p>
                            </div>
                        </b-row>
                        <b-row class="justify-content-between no-margin">
                            <div class="col-2 d-flex flex-column justify-content-center totais totais-esquerda">
                                <p>CDAs visualizadas na tela</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding fundo-cinza">
                                <p>{{obterTotal()}}</p>
                            </div>
                            <div></div>
                            <div class="col-2 d-flex flex-column justify-content-center totais">
                                <p>Protesto frustrado</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding blocoFrustrados">
                                <p>{{obterFrustrado()}}</p>
                            </div>
                            <div></div>
                            <div  class="col-2 d-flex flex-column justify-content-center totais totais-direita">
                                <p>Valor parcelado da Remessa</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding blocoExitoso">
                                <p>{{totaisRemessa.valorParcelado}}</p>
                            </div>
                        </b-row>
                        <b-row class="justify-content-between no-margin">
                            <div class="col-2 d-flex flex-column justify-content-center totais totais-esquerda">
                                <p>CDAs não mapeadas (erro)</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding fundo-erro">
                                <p>{{obterDiferenca()}}</p>
                            </div>
                            <div></div>
                            <div class="col-2 d-flex flex-column justify-content-center totais">
                                <p>Protesto exitoso</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding blocoExitoso">
                                <p>{{obterExitoso()}}</p>
                            </div>
                            <div></div>
                            <div class="col-2 d-flex flex-column justify-content-center totais totais-direita">
                                <p>Valor quitado da Remessa</p>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center somatorio no-padding blocoExitoso">
                                <p>{{totaisRemessa.valorQuitado}}</p>
                            </div>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import { mapActions } from 'vuex'
    import Item from "./CompItem";
    import axios from 'axios'
    import ConsultaDashboard from "./consulta/ConsultaDashboard";

    export default {
        name: 'AcompanhamentoProtesto',
        components: {
            Item,
            ConsultaDashboard
        },
        data() {
            return {
                dataMonitoramento: null,
                dataSelecionada: null,
                ano: null,
                mes: null,
                tipoConsulta: false,
                qtdTotalProtestos: null,
                totaisRemessa: {
                    valorNaoRecuperado: '...',
                    valorParcelado: '...',
                    valorQuitado: '...'
                },
                labelMes: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            }
        },
        methods: {
            ...mapActions(['setDataAcompanhamentoProtesto']),
            focusDataMonitoramento() {
                this.$refs.dataMonitoramentoField.openMenu();
            },
            obterQuantidadeTotalProtestos() {
                this.$store.commit("setMessages", {});

                this.resultado = [];

                const consulta = {
                    ano: this.ano,
                    mes: this.mes
                };

                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;
                axios.post(`${urlApi}/v1/dashboardProtesto/obterTotal`, consulta, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }).then(response => {
                    this.qtdTotalProtestos = response.data;
                    if(this.qtdTotalProtestos == 0){
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Não há CDAs obtidas no período.'] });
                    }
                });
            },
            obterValoresTotais() {
                this.$store.commit("setMessages", {});

                this.resultado = [];

                const consulta = {
                    ano: this.ano,
                    mes: this.mes
                };

                this.totaisRemessa = {
                    valorNaoRecuperado: '...',
                    valorParcelado: '...',
                    valorQuitado: '...'
                };

                const token = JSON.parse(this.$store.getters.getUser).access_token;
                const urlApi = process.env.VUE_APP_ROOT_API;
                axios.post(`${urlApi}/v1/dashboardProtesto/obterValoresTotais`, consulta, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }).then(response => {
                    this.totaisRemessa = response.data;
                });
            },
            obterTotal() {
                if (this.$refs.item0 != undefined && this.$refs.item0.quantidade != null &&
                    this.$refs.item1.quantidade != null && this.$refs.item11.quantidade != null &&
                    this.$refs.item2.quantidade != null && this.$refs.item3.quantidade != null &&
                    this.$refs.item4.quantidade != null && this.$refs.item5.quantidade != null &&
                    this.$refs.item6.quantidade != null && this.$refs.item7.quantidade != null &&
                    this.$refs.item8.quantidade != null && this.$refs.item9.quantidade != null &&
                    this.$refs.item10.quantidade != null) {
                    return this.$refs.item0.quantidade + this.$refs.item1.quantidade +
                        this.$refs.item2.quantidade + this.$refs.item3.quantidade +
                        this.$refs.item4.quantidade + this.$refs.item5.quantidade +
                        this.$refs.item6.quantidade + this.$refs.item7.quantidade +
                        this.$refs.item8.quantidade + this.$refs.item9.quantidade +
                        this.$refs.item10.quantidade + this.$refs.item11.quantidade;
                }

                return '...';
            },
            obterDiferenca() {
                if (this.obterTotal() != '...' && this.qtdTotalProtestos != null) {
                    return this.qtdTotalProtestos > this.obterTotal() ? this.qtdTotalProtestos - this.obterTotal() :
                        this.obterTotal() - this.qtdTotalProtestos;
                }

                return '...';
            },
            obterFluxo() {
                if (this.obterTotal() != "..." && this.obterTotal() == 0) {
                    return '0 (0%)';
                } else if (this.$refs.item4 != undefined && this.$refs.item4.quantidade != null &&
                    this.$refs.item5.quantidade != null && this.$refs.item6.quantidade != null &&
                    this.obterTotal() != "...") {
                    let total = this.$refs.item4.quantidade + this.$refs.item5.quantidade +
                        this.$refs.item6.quantidade;
                    let porcentagem = (total * 100) / this.obterTotal();
                    porcentagem = (Math.round(porcentagem * 100) / 100).toFixed(2).toString().replace(".", ",");
                    return total + ' (' + porcentagem + '%)';
                }

                return '...';
            },
            obterFrustrado() {
                if (this.obterTotal() != "..." && this.obterTotal() == 0) {
                    return '0 (0%)';
                } else if (this.$refs.item0 != undefined && this.$refs.item0.quantidade != null &&
                    this.$refs.item1.quantidade != null && this.$refs.item2.quantidade != null &&
                    this.$refs.item3.quantidade != null && this.obterTotal() != "...") {
                    let total = this.$refs.item0.quantidade + this.$refs.item1.quantidade +
                        this.$refs.item2.quantidade + this.$refs.item3.quantidade;
                    let porcentagem = (total * 100) / this.obterTotal();
                    porcentagem = (Math.round(porcentagem * 100) / 100).toFixed(2).toString().replace(".", ",");
                    return total + ' (' + porcentagem + '%)';
                }

                return '...';
            },
            obterExitoso() {
                if (this.obterTotal() != "..." && this.obterTotal() == 0) {
                    return '0 (0%)';
                } else if (this.$refs.item7 != undefined && this.$refs.item7.quantidade != null &&
                    this.$refs.item8.quantidade != null && this.$refs.item9.quantidade != null &&
                    this.$refs.item10.quantidade != null && this.$refs.item11.quantidade != null &&
                    this.obterTotal() != "...") {
                    let total = this.$refs.item7.quantidade + this.$refs.item8.quantidade +
                        this.$refs.item9.quantidade + this.$refs.item10.quantidade + this.$refs.item11.quantidade;
                    let porcentagem = (total * 100) / this.obterTotal();
                    porcentagem = (Math.round(porcentagem * 100) / 100).toFixed(2);
                    return total + ' (' + porcentagem + '%)';
                }

                return '...';
            }
        },
        watch: {
            dataMonitoramento() {
                if (this.dataMonitoramento._i != undefined) {
                    this.dataSelecionada = new Date(this.dataMonitoramento._i + "/02");
                    this.ano = this.dataSelecionada.getFullYear();
                    this.mes = this.dataSelecionada.getMonth() + 1;
                    this.$store.commit('setDataAcompanhamentoProtesto', this.dataSelecionada);
                }
                this.qtdTotalProtestos = null;
                this.obterQuantidadeTotalProtestos();
                this.obterValoresTotais();
            }
        },
        mounted() {
            var dataAtual = new Date();
            const dataAtualRep = new Date(this.$store.getters.getDataAcompanhamentoProtesto);
            if (dataAtualRep != null) {
                dataAtual = dataAtualRep;
            }

            this.ano = dataAtual.getFullYear();
            this.mes = dataAtual.getMonth() + 1;

            this.dataMonitoramento = this.ano + "-" + this.mes + "-" + "02";
            this.dataSelecionada = new Date(this.ano + "/" + this.mes + "/02");
            this.$store.commit('setDataAcompanhamentoProtesto', this.dataSelecionada);
        }
    };
</script>


<style scoped>
    .blocoFrustrados {
        background-color: #F4CCCC;
        border: 1px dashed;
    }

    .blocoFluxo {
        background-color: #F3F3F3;
        border: 1px dashed;
    }

    .blocoExitoso {
        background-color: #D9EAD3;
        border: 1px dashed;
    }

    .no-margin {
        margin: 0 !important;
    }

    .no-padding {
        padding: 0 !important;
    }

    .seta {
        text-align: center !important;
    }

    .seta-interna {
        width: 0 !important;
        text-align: center !important;
    }

    .border-down-exitoso {
        margin: 0 !important;
        border-bottom: none;
    }

    .arrow-exitoso {
        border-top: none;
        margin-bottom: -1px;
        margin-left: 1px;
        border-bottom: none;
    }

    .totais-esquerda {
        width: 450px;
    }

    .totais-direita {
        width: 250px;
    }

    .totais {
        text-align: right;
        display: inline-block !important;
    }

    .totais p {
        margin: 0 !important;
    }

    .somatorio {
        text-align: center;
        width: 150px;
        max-height: 23px;
    }

    .somatorio p {
        margin: 0 !important;
    }

    .fundo-cinza {
        background-color: #CCCCCC;
        border: 0.5px solid black;
    }

    .fundo-erro {
        background-color: #FF0000;
        border: 0.5px solid black;
    }

    .seta-align-top {
        margin-top: 30px;
    }

    .largura-seta {
        width: 5%;
    }

    .largura-item {
        width: 21%;
    }

    .seta-fluxo {
        margin-right: -6px;
        margin-left: -6px;
        border-right: none;
        border-left: none;
    }

    .border-right-none {
        border-right: none;
    }

    .border-left-none {
        border-left: none;
    }

    .border-sides-none {
        border-right: none;
        border-left: none;
    }
</style>
